import {Dialogues} from './Dialogues';
export default Dialogues;
